import { Category } from '../types/Category';

export interface PaginationPageLimit {
  label: string;
  value: number;
}

// TODO this needs to be data driven
export const getDefaultPageLimitOptions = (category: Category): PaginationPageLimit[] => {
  // If holiday, christmas, or new years clp
  if (category.categoryId === 67 || category.categoryId === 68 || category.categoryId === 65) {
    return [
      { label: 'View 24', value: 24 },
      { label: 'View 48', value: 48 },
      { label: 'View All', value: category.products.length }
    ];
  } else {
    return [
      { label: 'View 15', value: 15 },
      { label: 'View 30', value: 30 },
      { label: 'View All', value: category.products.length }
    ];
  }
};

// Sourced from Magento
export const cardCategoryIds = [
  61,
  62,
  102,
  175,
  112,
  67,
  68,
  65,
  254,
  255,
  256,
  264,
  266,
  276,
  292,
  295,
  297,
  298,
  304,
  305,
  308
];
